import { Navigate, useSearchParams } from 'react-router-dom';

import {
  COMPLIANCE_DASHBOARD_PATH,
  buildComplianceDocumentPath,
  inferComplianceArtifactKind,
} from './core/complianceRoutes';

/** `/compliance` → `/compliance/dashboard`, matching Pulse index → `/pulse/dashboard`. */
export function ComplianceIndexRedirect() {
  return <Navigate to={COMPLIANCE_DASHBOARD_PATH} replace />;
}

/**
 * Keeps bookmarks to `/compliance/policy` and `/compliance/dashboard/policy` working
 * by routing to the kind-scoped editor.
 */
export function CompliancePolicyLegacyRedirect() {
  const [searchParams] = useSearchParams();
  const country = searchParams.get('country') ?? '';
  const requirementKey = searchParams.get('requirementKey') ?? '';
  const applicability = searchParams.get('applicability');
  if (!country || !requirementKey) {
    return <Navigate to={COMPLIANCE_DASHBOARD_PATH} replace />;
  }
  const kind = inferComplianceArtifactKind(requirementKey);
  const intent = applicability === '1' ? 'applicability' : 'edit';
  return <Navigate to={buildComplianceDocumentPath(kind, country, requirementKey, intent)} replace />;
}
